// extracted by mini-css-extract-plugin
module.exports = {"HomePageSlider__wrapper":"HomePageSlider_HomePageSlider__wrapper__YsQSt"};